export default class ResponseError extends Error {
    constructor (message, { status, translationKey }) {
        super(message);

        this.name = "ResponseError";
        this.date = new Date();

        this.response = {
            status,
            data: [
                { text: translationKey }
            ]
        };

    }
}
